import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo, EndSessionRequest } from '@azure/msal-browser';
import { BehaviorSubject } from 'rxjs';
import { CustomerService } from './customer.service';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private activeAccountSubject = new BehaviorSubject<AccountInfo | null>(null);
  activeAccount$ = this.activeAccountSubject.asObservable();

  private allAccountSubject = new BehaviorSubject<AccountInfo[] | null>(null);
  allAccounts$ = this.allAccountSubject.asObservable();

  constructor(
    private authService: MsalService,
    private customerService: CustomerService,
  ) {
  }

  setActiveAccount(activeAccount: AccountInfo | null) {
    this.activeAccountSubject.next(activeAccount);

    if (activeAccount != null) this.customerService.fetchCurrentUser$().subscribe();
  }

  setAccounts(accounts: AccountInfo[]) {
    this.allAccountSubject.next(accounts);
  }

  checkAndSetActiveAccount() {
    const activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      const accounts = this.authService.instance.getAllAccounts();
      this.setActiveAccount(accounts[0]);
      this.authService.instance.setActiveAccount(accounts[0]);
    } else if (activeAccount) {
      this.setActiveAccount(activeAccount);
    }
  }

  logoutAccount() {
    const request: EndSessionRequest = {
      account: this.activeAccountSubject.value,
    };
    localStorage.clear();
    this.authService.logoutRedirect(request);
  }
}
